<div id="demonstrations_list_content">  
       
    <div id="demonstrations_list_header">
        <div class="page_title_content">
            <div class="page_title">{{'DEMONSTRATIONS_LIST.TITLE' | translate}}</div>
            <div class="page_subtitle">{{'DEMONSTRATIONS_LIST.SUBTITLE' | translate}}</div>
        </div>

         @if(this.matches.length > 0 && this.dataService.operation.demonstrationsContent?.isValidationByCodeVisible){
            <demooz-button type="button" id="button_modal_validation_code_demo" label="{{'DEMONSTRATIONS_LIST.BUTTON_VALIDATION_CODE' | translate}}" [withMargin]="false" (click)="this.openModalValidationCode()"/> 
        }

    </div>
    
    @if(this.matches.length > 0){
    
        <div id="demonstrations_list">
            @for(match of this.matches.slice(0, this.maxMatchesDisplayed); track $index){
                <app-demonstrations-item [match]="match"/>
            }
                        
            @if(this.matches.length > this.maxMatchesDisplayed){
                <div id="demonstrations_list_plus">
                    <div id="demonstrations_list_preview">
                        @for(match of this.matches.slice((this.maxMatchesDisplayed-1), ((this.maxMatchesDisplayed-1)+this.nbMatchesPreview)); track $index){
                            <div>
                                {{match.tester.firstName.charAt(0)}}{{match.tester.lastName.charAt(0)}}
                            </div>
                        }
                        @if(this.matches.length > (this.maxMatchesDisplayed+this.nbMatchesPreview)){
                            <div>
                                {{this.matches.length - (this.maxMatchesDisplayed+this.nbMatchesPreview)}}+
                            </div>
                        }
                    </div>
                    <demooz-button type="button" id="button_demonstrations_see_all" label="{{'DEMONSTRATIONS_LIST.BUTTON_SEE_ALL' | translate}}" [withShadow]="true" [withBorder]="false" [invertColor]="true" color="primary" (click)="this.seeAllDemonstrations()"/> 
                </div>
            }
            
            @if(this.matchesArchived.length > 0){
                <div id="demonstrations_archived">
                    <div>{{'DEMONSTRATIONS_LIST.DEMONSTRATIONS_ARCHIVED' | translate}}</div>
                    <div>{{this.matchesArchived.length}}</div>
                </div>
            }
        </div>
        
    }
    @else{
        <demooz-message type="info">{{'DEMONSTRATIONS_LIST.MSG_NO_DEMONSTRATION' | translate}}</demooz-message>
    }
        
    @if(this.showBtnShareDemo){
        <div id="button_share_link_demonstration_content">
            <demooz-button type="button" id="button_share_link_demonstration" label="{{'DEMONSTRATIONS_LIST.BUTTON_SHARE_LINK' | translate}}" (click)="this.shareLinkDemonstration()"/> 
        </div>
    }
    
</div>

<demooz-modal #modalValidationCode size="small">
    <app-demonstrations-validation-code (onValidationCode)="this.onValidationCode($event)"/>
</demooz-modal>